var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-col",
    { staticClass: "el-col-xxs-24", attrs: { xs: 12, sm: 12, lg: 6 } },
    [
      _c(
        "el-row",
        {
          class: [
            "agent-card-info",
            "card-softstyle",
            "enter-animation",
            "animationdelay-" + _vm.cardKey + "s"
          ]
        },
        [
          _c("el-col", { staticClass: "icon-col", attrs: { span: 8 } }, [
            _c("span", { style: "color: " + _vm.iconColor }, [
              _c("i", { class: ["fas", "fa-" + _vm.icon] })
            ])
          ]),
          _vm._v(" "),
          _c("el-col", { staticClass: "info-col", attrs: { span: 12 } }, [
            _c("div", { staticClass: "label" }, [_vm._v(_vm._s(_vm.label))]),
            _vm._v(" "),
            !_vm.loadingInfo
              ? _c(
                  "div",
                  { staticClass: "value" },
                  [
                    _c("count-to", {
                      staticClass: "agentInfoCount",
                      attrs: {
                        "start-val": 0,
                        "end-val": _vm.value,
                        duration: 2600
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }